function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
/* eslint-disable no-new-func */

/* eslint-disable no-useless-escape */


import { isObservable, extendObservable, set } from 'mobx';
var hasOwn = {}.hasOwnProperty;
var toString = {}.toString;
var fnToString = hasOwn.toString;
var ObjectFunctionString = fnToString.call(Object); // eslint-disable-next-line

var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
/**
 * 默认检验规则
 */

var ruleMsg = {
  required: '必填项',
  number: '必须为有效数字',
  maxLength: '最长不超过$value个字符',
  minLength: '最短不少于$value个字符',
  max: "最大数值$value",
  min: "最小数值$value",
  float: '必须为浮点数字',
  integer: '必须为整数数字',
  digit: '必须为数字',
  email: 'email地址不合法',
  phone: '不是有效手机号或电话号码',
  mobile: '请输入11位手机号码',
  tel: '电话(区号-)7或8位数字',
  qq: '不是有效QQ号',
  id: "身份证号为15位或18位数字",
  zipcode: "邮政编码是6位数字",
  a_zA_Z: "由英文字母组成(不区分大小写)",
  A_Z: "由大写英文字母组成",
  a_z: "由小写英文字母组成",
  a_zA_Z0_9: "由英文字母或数字组成(不区分大小写)",
  a_zA_Z0_9_: "由英文字母或数字或下划线组成(不区分大小写)",
  uri: "请输入正确的uri地址",
  http: "请输入正确的http地址",
  account: "字母开头，包含字母或数字或下划线的5-16个字符",
  password: "字母开头，包含字母、数字和下划线的6-18个字符",
  date: "日期格式应为2020-2-22 或 2020-04-05类型",
  datetime: "日期时间格式为2020-2-22 17:34:22"
};
/**
 * 校验正则规则
 */

export var ruleRegExp = {
  email: /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/,
  mobile: /^1[3-9]\d{9}$/,
  tel: /^(\d{3,4}-)?\d{7,8}$/,
  phone: /^((\d{3,4}-\d{7,8})|(\d{7,8})|(1[3-9]\d{9}))$/,
  qq: /^[1-9][0-9]{4,9}$/,
  zipcode: /^[0-9]\d{5}$/,
  id: /^[1-9](\d{13}|\d{16})[0-9Xx]$/,
  integer: /^-?\d+$/,
  float: /^(-?\d+)(\.\d+)?$/,
  number: /^-?d+(\.{1}\d+)?$/,
  digit: /^\d+$/,
  a_zA_Z: /^[A-Za-z]+$/,
  A_Z: /^[A-Z]+$/,
  a_z: /^[a-z]+$/,
  a_zA_Z0_9: /^[A-Za-z0-9]+$/,
  a_zA_Z0_9_: /^[A-Za-z0-9_]+$/,
  uri: /^[a-zA-z]+:\/\/(\S+)$/,
  http: /^http(s)?:\/\/(\S+)$/,
  account: /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/,
  // 帐号是否合法(字母开头，允许5-16字节，允许字母数字下划线),
  password: /^[a-zA-Z]\w{5,17}$/,
  // 以字母开头，长度在6~18之间，只能包含字母、数字和下划线
  date: /^\d{4}-\d{1,2}-\d{1,2}/,
  datetime: /^\d{4}-\d{1,2}-\d{1,2}\s\d{1,2}:\d{1,2}(:\d{1,2})?$/
};
/**
 * 字符串校验
 * @param {*} val 
 */

export function checkString(val) {
  if (typeof val !== "string") {
    return {};
  }

  var results = {
    isEmpty: val === ""
  };

  for (var key in ruleRegExp) {
    if (ruleRegExp.hasOwnProperty(key)) {
      var format = ruleRegExp[key];
      results[key] = format.test(val);
    }
  }

  return results;
}
/**
 * 获取校验规则错误提示语
 * @param {} rule 
 * @param {*} msg 
 * @param {*} value 
 */

function _getRuleMsg(rule, msg, value) {
  if (typeof rule == "string") {
    rule = {
      type: rule,
      msg: msg,
      value: value
    };
  }

  var _msg = ruleMsg[rule.type] || 'field error';

  if (rule.msg && rule.msg.length) {
    _msg = rule.msg;
  }

  return _msg.replace(/\$value/img, rule.value !== undefined ? rule.value : "");
}
/**
 * 获取正则校验结果
 * @param {*} rule 
 * @param {*} string 
 */


function _getRegExpRule(rule, string) {
  var reg = rule.type === "regexp" ? rule.value : ruleRegExp[rule.type];
  var regExp;

  if (typeof reg == "string" && reg.length) {
    regExp = new RegExp(reg);
  }

  if (_typeof(reg) === "object" && reg.constructor === RegExp) {
    regExp = reg;
  }

  if (regExp && !regExp.test(string)) {
    return _getRuleMsg(rule);
  }

  return false;
}
/**
 * 执行规则校验
 * @param {*} field 
 * @param {*} rule 
 * @param {*} filter
 */


function _verifyFieldRule(field, rule, filter) {
  var err;

  switch (rule.type) {
    case "required":
      if (!field.value && field.value !== 0 || field.isEmpty) {
        err = _getRuleMsg(rule);
      }

      break;

    case "number":
      if (!field.isNumber) {
        err = _getRuleMsg(rule);
      }

      break;

    case "float":
      if (!field.isNumber) {
        err = _getRuleMsg(rule);
      }

      break;

    case "integer":
      if (!field.isInt) {
        err = _getRuleMsg(rule);
      }

      break;

    case "maxLength":
      if (rule.value && field.length > rule.value) {
        err = _getRuleMsg(rule);
      }

      break;

    case "minLength":
      if (rule.value && field.length < rule.value) {
        err = _getRuleMsg(rule);
      }

      break;

    case "max":
      if (!field.isNumber) {
        err = _getRuleMsg("number");
      } else {
        if (rule.value && field.numberValue > rule.value) {
          err = _getRuleMsg(rule);
        }
      }

      break;

    case "min":
      if (!field.isNumber) {
        err = _getRuleMsg("number");
      } else {
        if (rule.value && field.numberValue < rule.value) {
          err = _getRuleMsg(rule);
        }
      }

      break;

    default:
      err = _getRegExpRule(rule, field.stringValue);
      break;
  }

  if (typeof filter === 'function') {
    err = filter(rule, field, err);
  }

  return {
    message: err,
    rule: rule
  };
}
/**
 * 处理格式规则
 * @param {*} format 
 * @param {*} rules 
 * @returns 
 */


function parseFormatRule(format, rules) {
  rules = rules || [];
  var rule;

  if (typeof format === "string") {
    rule = {
      type: format
    };
  } else if (_typeof(format) === "object" && format instanceof RegExp) {
    rule = {
      type: "regexp",
      value: format
    };
  } else if (isArray(format)) {
    for (var index = 0; index < format.length; index++) {
      rules = parseFormatRule(format[index], rules);
    }
  }

  rule && rules.push(rule);
  return rules;
}
/**
 * 校验规则
 * @param {*} value 
 * @param {*} _rules 
 */


export function verifyFieldValue(value, _rules, format, errTip, filter) {
  var rules = _rules || [];
  var error = "";

  if (format) {
    var _ru = parseFormatRule(format);

    rules.push.apply(rules, _toConsumableArray(_ru));
  }

  if (!rules || !rules.length || _typeof(rules) !== "object") {
    return {};
  }

  var stringValue = value + "";
  var numberValue = parseFloat(value);
  var intValue = parseInt(value);
  var integerString = intValue + "";
  var isInt = stringValue === integerString;
  var isString = typeof value === "string";
  var isObject = _typeof(value) === "object" && value !== null;
  var isArray = isObject && value instanceof Array;
  var isEmpty = (isString || isArray) && value.length === 0;
  var field = {
    value: value,
    numberValue: numberValue,
    stringValue: stringValue,
    isNumber: typeof numberValue === 'number',
    isString: isString,
    isTrue: stringValue === "true",
    isFalse: stringValue === "false",
    isEmpty: isEmpty,
    isInt: isInt,
    isObject: isObject && !isArray,
    isArray: isArray,
    isRequired: false,
    isMaxLength: false,
    length: (isString || isArray) && value.length,
    maxLength: 0
  };
  var errors = {};
  rules.forEach(function (rule) {
    if (typeof rule == "string") {
      rule = {
        type: rule
      };
    }

    var err = _verifyFieldRule(field, rule, filter);

    if (rule.type === "maxLength") {
      field.maxLength = rule.value;
    }

    if (rule.type === "integer") {
      field.integer = true;
    }

    if (err && err.message) {
      errors[rule.type] = err.message;

      if (rule.type === "maxLength") {
        field.isMaxLength = true;
      }
    }
  });
  var errs = [];

  if (errors.required) {
    errs.push(errors.required);
    field.isRequired = true;
    delete errors.required;
  }

  if (!field.isEmpty && Object.keys(errors).length) {
    for (var err in errors) {
      if (/max|min/i.test(err) && (errors.number || errors.float || errors.integer)) {
        continue;
      }

      if (errors.hasOwnProperty(err) && errs.indexOf(errors[err]) === -1) {
        errs.push(errors[err]);
      }
    }
  }

  error = errs.join(", ");
  field.errorMsg = errs.length ? errTip ? errTip : error : '';
  field.hasError = errs.length ? true : false;
  field.errors = errors;
  field.hasError && console.error('verifyFieldValue -> error', field.errorMsg, field.errors);
  return field;
}
/**
 * 判断是否为空对象
 * @param {*} obj 
 */

export function isEmptyObject(obj) {
  var name;

  for (name in obj) {
    return false;
  }

  return true;
}
/**
 * 判断是否为普通对象
 * @param {} obj 
 */

export function isPlainObject(obj) {
  var proto, Ctor;

  if (!obj || toString.call(obj) !== "[object Object]") {
    return false;
  }

  proto = Object.getPrototypeOf(obj);

  if (!proto) {
    return true;
  }

  Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
  return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
}
/**
 * 浅相等比较
 * @param {*} obj 
 * @param {*} other 
 */

export function isEqualObjects(obj, other) {
  if (!isObject(obj) || !isObject(other)) {
    return false;
  }

  if (Object.keys(obj).length !== Object.keys(other).length) {
    return false;
  }

  if (isEmptyObject(obj) && isEmptyObject(other)) {
    // 空对象相等
    return true;
  }

  for (var key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      if (obj[key] !== other[key]) {
        return false;
      }
    }
  }

  return true;
}
/**
 * 对象字段映射
 * @param {*} obj 
 * @param {*} map 
 */

export function objectMap(obj, map) {
  if (_typeof(map) === 'object') {
    for (var key in map) {
      if (map.hasOwnProperty(key)) {
        var field = map[key];
        obj[key] = obj.hasOwnProperty(field) ? obj[field] : obj[key];
      }
    }
  }

  return obj;
}
/**
 * 去除字符串首尾空格
 * @param {string} string 
 */

export function trim(string) {
  return string.replace(/^\s+/, '').replace(/\s+$/, '');
}
/**
 * 首字母大写
 * @param {*} str 
 */

export function firstUpperCase(str) {
  str = str || '';
  return str.substring(0, 1).toUpperCase() + str.substring(1);
}
/**
 * 合并对象（浅拷贝）
 * @param {object} obj1 
 * @param {object} obj2 
 * @param {object} newObj 
 */

export function extend(obj1, obj2, newObj) {
  var key;

  if (_typeof(obj2) === "object" && _typeof(obj1) === "object") {
    if (newObj) {
      var obj = {};

      for (key in obj1) {
        obj[key] = obj1[key];
      }

      for (key in obj2) {
        obj[key] = obj2[key];
      }

      return obj;
    } else {
      for (key in obj2) {
        obj1[key] = obj2[key];
      }
    }
  }

  return obj1;
}
/**
 * 解析JSON
 * @param {any} data 
 */

export function parseJSON(data) {
  if (window.JSON && JSON.parse) {
    try {
      var res = JSON.parse(data);
      return res;
    } catch (error) {}
  }

  var requireNonComma,
      depth = null,
      str = trim(data + "");
  return str && !trim(str.replace(rvalidtokens, function (token, comma, open, close) {
    if (requireNonComma && comma) {
      depth = 0;
    }

    if (depth === 0) {
      return token;
    }

    requireNonComma = open || comma;
    depth += !close - !open;
    return "";
  })) ? // eslint-disable-next-line no-new-func
  Function("return " + str)() : data;
}
/**
 * 抛出错误
 * @param {string} str 
 */

export function throwError(str) {
  throw new Error(str);
}
/**
 * 转换成有效的url参数
 * @param value 
 */

export function convert_to_valid_query(value) {
  if (!value && value !== 0) {
    return '';
  }

  if (_typeof(value) === 'object') {
    if (value.length === 0 || Object.keys(value).length === 0) {
      return '';
    }

    value = JSON.stringify(value);
  }

  return '' + value;
}
/**
 * 获取所有URL参数
 * @returns 
 */

export function getQueryParams(variable) {
  var params = {};
  var query = window.location.search.substring(1);
  var vars = query.split("&");

  for (var i = 0; i < vars.length; i++) {
    var pair = (vars[i] || '').split("=");

    if (!pair[0]) {
      continue;
    }

    params[pair[0]] = decodeURIComponent(pair[1] || '');

    if (variable && pair[0] === variable) {
      return params[pair[0]];
    }
  }

  return variable ? null : params;
}
/**
* 获取uri请求参数
* @param {*} variable 
* @returns 
*/

export function getQueryParam(variable) {
  return getQueryParams(variable);
}
/**
 * 解析url请求参数
 * @param {*} url 
 */

export function parse_url_query(query) {
  var querys = (query || '').split("&");
  var queryObj = {};

  for (var index = 0; index < querys.length; index++) {
    var kv = querys[index] || "";

    var _kv$split = kv.split("="),
        _kv$split2 = _slicedToArray(_kv$split, 2),
        k = _kv$split2[0],
        v = _kv$split2[1];

    if (k && typeof v !== 'undefined') {
      queryObj[k] = v;
    }
  }

  return queryObj;
}
/**
 * 构建url请求参数
 * @param {*} query 
 * @returns 
 */

export function get_url_query_arr(query) {
  var qs = [];

  if (_typeof(query) === 'object') {
    for (var key in query) {
      if (Object.hasOwnProperty.call(query, key)) {
        var value = convert_to_valid_query(query[key]);
        qs.push(key + '=' + value);
      }
    }
  }

  return qs;
}
/**
 * URL增加参数
 * @param {string} url 
 * @param {string} key 
 * @param {string} value 
 */

export function add_url_query(url, key, value) {
  var url_hash = url.split("#");
  url = url_hash[0]; // eslint-disable-next-line no-useless-escape

  var urlParamstring = url.replace(/[^\?]+\?([^=]+=[\S]+)?/i, "$1");
  var query = {};

  if (arguments.length === 2) {
    query = key || '';
  } else {
    query[key] = value;
  }

  if (_typeof(query) === 'object') {
    var qs = get_url_query_arr(query);
    query = qs.join('&');
  }

  if (!query) {
    return url;
  }

  if (urlParamstring !== url) {
    url = url + '&' + query;
  } else {
    url = url + '?' + query;
  }

  return url;
}
/**
* 判断是否是数组
* @param obj 
* @returns 
*/

export function isArray(obj) {
  return Array.isArray ? Array.isArray(obj) : Object.prototype.toString.call(obj) === '[object Array]';
}
/**
* 判断是否是object
* @param obj 
* @returns 
*/

export function isObject(obj) {
  return _typeof(obj) === 'object' && Object.prototype.toString.call(obj) === '[object Object]' && obj !== null;
}
/**
 * 更新默认检验规则 
 * @param {*} rulesMap 
 * @returns 
 */

export function updateDefaultRules(rulesMap) {
  if (!isObject(rulesMap)) {
    return;
  }

  for (var key in rulesMap) {
    if (Object.hasOwnProperty.call(rulesMap, key)) {
      var rule = rulesMap[key];

      if (rule && rule.msg && rule.value) {
        ruleRegExp[key] = rule.value;
        ruleMsg[key] = rule.msg;
      }
    }
  }
}
/**
 * 判断是手机
 * @returns 
 */

export function isMobile() {
  return browserType() === 'phone';
}
/**
 * 判断IOS
 * @returns 
 */

export function isIOS() {
  return browserPlantform() === 'ios';
}
/**
 * 判断Android
 * @returns 
 */

export function isAndroid() {
  return browserPlantform() === 'android';
}
/**
 * 判断微信
 * @returns 
 */

export function isWeixin() {
  var sUserAgent = navigator.userAgent.toLowerCase();
  return !!sUserAgent.match(/micromessenger/i);
}
export function browserType() {
  var sUserAgent = navigator.userAgent.toLowerCase();
  var bIsIpad = sUserAgent.match(/ipad/i);
  var bIsIphoneOs = sUserAgent.match(/iphone os/i);
  var bIsMidp = sUserAgent.match(/midp/i);
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i);
  var bIsUc = sUserAgent.match(/ucweb/i);
  var bIsAndroid = sUserAgent.match(/android/i);
  var bIsCE = sUserAgent.match(/windows ce/i);
  var bIsWM = sUserAgent.match(/windows mobile/i);
  var bIsWX = sUserAgent.match(/micromessenger/i);

  if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bIsWX) {
    return "phone";
  } else {
    return "pc";
  }
}
export function browserPlantform() {
  var sUserAgent = navigator.userAgent.toLowerCase();
  var bIsIpad = sUserAgent.match(/ipad/i);
  var bIsIphoneOs = sUserAgent.match(/iphone os/i);
  var bIsMidp = sUserAgent.match(/midp/i);
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i);
  var bIsUc = sUserAgent.match(/ucweb/i);
  var bIsAndroid = sUserAgent.match(/android/i);
  var bIsCE = sUserAgent.match(/windows ce/i);
  var bIsWM = sUserAgent.match(/windows mobile/i);

  if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
    if (bIsIpad || bIsIphoneOs) {
      return "ios";
    } else {
      return "android";
    }
  } else {
    return "pc";
  }
}
/**
  * 获取obj by index path
  * @param {*} idx 
  * @param {*} obj 
  * @description [0][1] ..
  */

export function _getObjByIndex(idx, obj, lastPath, extend, value) {
  var _idx = idx.replace(/[^\d\]\[]/g, '').replace(/\]\[/g, ',').replace(/^\[/, '').replace(/]$/, '').split(',');

  var res = obj,
      isSet = arguments.length === 5;

  if (_idx && idx.length) {
    for (var index = 0; index < _idx.length; index++) {
      var _index = _idx[index];
      var lastIndex = index === _idx.length - 1;

      if (!_index) {
        continue;
      }

      var i = void 0;

      try {
        i = parseInt(_index);
      } catch (error) {
        return undefined;
      }

      if (!lastIndex && typeof obj[i] === 'undefined') {
        setObjValue(obj, i, []);
      }

      if (_typeof(obj) !== 'object') {
        return undefined;
      }

      if (lastIndex && lastPath && extend && isSet) {
        setObjValue(obj, i, value);
      }

      obj = obj[i];

      if (lastIndex) {
        if (extend && !lastPath && _typeof(obj) !== 'object') {
          obj = {};
        }

        res = obj;
      }
    }
  }

  return res;
}
/**
 * 获取对象by path
 * @param {*} path 
 * @param {*} obj 
 */

export function _getObjByPath(path, obj, lastPath, extend, isSet, value) {
  if (!path || !obj || _typeof(obj) !== 'object') {
    return;
  }

  var matches = path.match(/([_a-z$A-Z0-9]+)?(((\s+)?\[(\s+)?\d+(\s+)?\](\s+)?)+)?/);

  if (!matches) {
    return;
  }

  var res = obj;

  var _matches = _slicedToArray(matches, 3),
      key = _matches[1],
      idxs = _matches[2];

  if (key && extend && !Object.prototype.hasOwnProperty.call(obj, key)) {
    setObjValue(obj, key, idxs ? [] : lastPath ? value : {});
  }

  if (key) {
    res = obj[key];
  }

  if (idxs && extend && typeof res === 'undefined') {
    res = [];
    setObjValue(obj, key, res);
  }

  if (idxs) {
    if (!res || _typeof(res) !== 'object') {
      return;
    }

    res = _getObjByIndex(idxs, res, lastPath, extend, value);
  } else {
    if (lastPath && extend && isSet === true) {
      setObjValue(obj, key, value);
    }
  }

  return res;
}
/**
 * 通过path获取对象
 * @param {*} path user.name.like[0][1].age
 * @param {*} obj 
 * @returns {any} 
 */

export function getObjByPath(path, obj, extend, value) {
  if (typeof path !== 'string') {
    return path;
  }

  var res,
      operator,
      isSet = arguments.length === 4;
  var reg = /^([\!]+)/; // !运算符处理

  var matches = path.match(reg);

  if (matches) {
    operator = matches[1];
    path = path.replace(reg, '');
  }

  var paths = path.split('.');

  for (var index = 0; index < paths.length; index++) {
    var key = paths[index];
    var lastPath = index === paths.length - 1;
    obj = _getObjByPath(key, obj, lastPath, extend, isSet, value);

    if (lastPath) {
      res = obj;
    } else {
      if (_typeof(obj) !== 'object') {
        return undefined;
      }
    }
  }

  if (operator) {
    return new Function('return ' + operator + 'res;')();
  }

  return res;
}
/**
 * 更新obj
 * @param {*} obj 
 * @param {*} key 
 * @param {*} value 
 * @param {*} merge 
 */

function setObjValue(obj, key, value, merge) {
  if (obj[key] && merge && _typeof(value) === 'object' && _typeof(obj[key]) === 'object') {
    extendObject(obj[key], value);
  } else if (isObservable(obj)) {
    set(obj, key, value);
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
* 更新obj by path
* @param path 
* @param obj 
* @param value 
*/


export function setObjByPath(obj, path, value) {
  if (!path || !obj) {
    return;
  }

  getObjByPath(path, obj, true, value);
}
/**
 * 扩展对象
 * @param obj 
 * @param data 
 */

export function extendObject(obj, data) {
  if (isObservable(obj)) {
    extendObservable(obj, data || {});
  } else {
    Object.assign(obj, data || {});
  }

  return obj;
}
/**
 * 无效值
 */

export function isVoidValue(value) {
  return typeof value === 'undefined' || value === null;
}
/**
 * 获取有效字符串值
 * @param {*} value 
 * @param {*} defaultValue 
 * @returns 
 */

export function getValidValue(value, defaultValue) {
  var toString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (isVoidValue(value)) {
    value = defaultValue;
  }

  return isVoidValue(value) ? undefined : toString ? '' + value : value;
}
/**
 * 获取有效字符串数组值
 * @param {*} value 
 * @param {*} defaultValue 
 */

export function getValidArrayValue(value, defaultValue) {
  var toString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!isArray(value)) {
    value = isVoidValue(value) ? [] : [value];
  }

  if (!isArray(defaultValue)) {
    defaultValue = isVoidValue(value) ? [] : [defaultValue];
  }

  return value.map(function (val, index) {
    return getValidValue(val, isVoidValue(defaultValue[index]) ? defaultValue[index] : defaultValue[0], toString);
  });
}
/**
 * 随机字符串id
 * @param {*} prefix 
 * @param {*} len 
 * @returns 
 */

export function uuid(prefix, len) {
  if (typeof prefix === 'number') {
    len = prefix;
  }

  len = len || 6;
  var uuid = Math.random().toString(36).replace("0.", "uu").slice(-1 * Math.abs(len > 10 ? 10 : len));
  return typeof prefix === 'string' ? prefix + uuid : uuid;
}
var utils = {
  verifyFieldValue: verifyFieldValue,
  verifyFieldRule: _verifyFieldRule,
  getRegExpRule: _getRegExpRule,
  getRuleMsg: _getRuleMsg,
  language: {
    ruleMsg: ruleMsg
  },
  ruleRegExp: ruleRegExp,
  checkString: checkString,
  isPlainObject: isPlainObject,
  objectMap: objectMap,
  trim: trim,
  extend: extend,
  parseJSON: parseJSON,
  throwError: throwError,
  add_url_query: add_url_query,
  uuid: uuid
};
export default utils;